import React from 'react'
import { Container, Card, CardHeader, HeaderTitle, Icon, Ul, Label } from '../styles/tiers'
import Header from '../views/common/Header'
import { LocaleContext } from '../routes'
import { useContext } from 'react'

export default function Tiers({ loyalty: { tiers } }) {
  const locale = useContext(LocaleContext)

  return (
    <Container>
      <Header title={locale.LEVELS} />
      <Label>{locale.TIERS_HINT}:</Label>
      {tiers.map((data) => {
        return (
          <Card>
            <CardHeader>
              <Icon alt="" src={require(`../planets/${data.type.toLowerCase()}.png`)} />
              <HeaderTitle>{locale[data.type]}</HeaderTitle>
            </CardHeader>

            <Ul>
              {data.hints.map(data => <li>{data}</li>)}
            </Ul>
          </Card>
        )
      })}
    </Container>
  )
}
